import { Injectable } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, Router } from '@angular/router';
import { CommonService } from 'app/shared/services/global/common.service';

@Injectable()
export class ItrGuard implements CanActivate {
    constructor(private router: Router, private commonService: CommonService) { }
    canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
        const itrId = returnItr();
        let itr4HufOrFirm = true;
        const partyType = localStorage.getItem('party_type') || null;
        if (partyType) {
            const party = JSON.parse(atob(partyType));
            if (itrId === 4 && (party.party_type === 2 || party.party_type === 3) && this.commonService.selectedYearId >= 2) {
                itr4HufOrFirm = false;
            }
        }
        
        if (itrId === 5 || itrId === 6) {
            this.router.navigate(['/dashboard/taxes-paid/tax-deducted/tds-2'], {
                queryParams: {
                    p_id: this.commonService.personID,
                    f_id: this.commonService.selectedYearId,
                    itr_id: itrId
                },
                queryParamsHandling: 'merge',
            });
            return true;
        }
        return itr4HufOrFirm;
    }
}

function returnItr() {
    let id = 1;
    let url = window.location.href;
    const retObject = {};
    let parameters;
    if (url.indexOf('?') === -1) {
        id = 1;
    }
    url = url.split('?')[1];
    parameters = url.split('&');
    for (let i = 0; i < parameters.length; i++) {
        retObject[parameters[i].split('=')[0]] = parameters[i].split('=')[1];
    }
    id = retObject['itr_id'] ? parseInt(retObject['itr_id'], 10) : 1;
    return id;
}
